import React, { createContext, useContext } from "react";
import useSessionTherapyContext from "lib/hooks/useSessionTherapyContext";

// Types for context value
type SessionBookingContextType = ReturnType<typeof useSessionTherapyContext>;

const SessionBookingContext = createContext<SessionBookingContextType | null>(null);

const SessionBookingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useSessionTherapyContext();
  return (
    <SessionBookingContext.Provider value={value}>
      {children}
    </SessionBookingContext.Provider>
  );
};

// Optional: custom hook for easier usage
const useSessionBooking = () => {
  const ctx = useContext(SessionBookingContext);
  if (!ctx) throw new Error("useSessionBooking must be used within a SessionBookingProvider");
  return ctx;
};

export { SessionBookingContext, SessionBookingProvider, useSessionBooking };
